import { api } from "..";

const endpoint = "/api/outbounds";

export const getOutboundList = async (params) => {
  const response = await api.get(endpoint, { params });
  return response;
};

export const createOutbound = async (data) => {
  const response = await api.post(endpoint, data);
  return response;
};

export const updateOutbound = async (id, data) => {
  const response = await api.put(`${endpoint}/${id}`, data);
  return response;
};

export const deleteOutbound = async (id) => {
  const response = await api.delete(`${endpoint}/${id}`);
  return response;
};

export const updateOutboundStatus = async (id, status) => {
  const response = await api.post(`${endpoint}/${id}/changeStatus`, JSON.stringify(status));
  return response;
};
